import React, { useEffect, useState } from "react";
import useUserStore from "../../utils/storeApp";
import MedInfoIcon from "../../assets/images/svg-icons-material-io/medical_information_FILL0_wght400_GRAD0_opsz48.svg";

const DetailsDirectory = () => {
  const [detailObj, setUserDetail] = useState([]);
  const { sharedObject } = useUserStore((state) => ({
    sharedObject: state.sharedObject,
  }));
  useEffect(() => {
    setUserDetail(sharedObject.userDirectSearch);
  }, [sharedObject.userDirectSearch]);
  function formatPhoneNumber(value) {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, "");
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 10)}`;
  }
  return (
    <div className="DetailsDirectory">
      <div className="modal fade" id="detailsDirectoryModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="DetailsDirectorySearch" aria-hidden="false" >
        <div className="modal-dialog modal-dialog-slideout">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title spacer-inline text-size3" id="myModalLabel" > Details </div>
              <button type="button" className="close" aria-label="Close" data-dismiss="modal" > <span aria-hidden="false">&times;</span> </button>
            </div>

            <form>
              <div className="modal-body">
                <div className="modal-content-body container">
                  <div className="details-header blk-clr">
                                      {sharedObject?.AdvSearchAnswers?.DirectoryType !==
                                          "Providers" ? (
                                          <>
                                                  <div>
                                                      <i className="bi bi-buildings-fill text-size5"></i>
                                                      <div className="text-size6 ft-wt spacer-margin7">
                                                          {detailObj?.name}
                                                      </div>
                                                  </div>
                                          </>
                                      ) : (
                                              
                                               <div >
                                                      <img src={MedInfoIcon} alt="Medical Information Icon" />
                                                      <div className="text-size6 ft-wt spacer-margin7">
                                                          {detailObj?.name}
                                                      </div>
                                                  </div>
                                      )}
                  </div>
                  <section className="field-wrapper">
                    <div>
                      <label>Address:</label>
                      <span className="sp-margin5">
                        {detailObj?.address}, {detailObj?.city},
                        {detailObj?.state} {detailObj?.zip}
                      </span>
                    </div>
                    <div className="spacer-inline">
                      <label>Phone:</label>
                      <span className="sp-margin5">
                        {detailObj?.phone
                          ? formatPhoneNumber(detailObj?.phone.substring(0, 10))
                          : ""}
                      </span>
                      <label>Ext:</label>
                      <span className="sp-margin5">
                        {detailObj?.phone?.substring(
                          10,
                          detailObj?.phone.length
                        )}
                      </span>
                    </div>
                    <br />
                    <div className="spacer-inline">
                      <label>Fax:</label>
                      <span className="sp-margin5">
                        {detailObj?.fax
                          ? formatPhoneNumber(detailObj?.fax.substring(0, 10))
                          : ""}
                      </span>
                      <label>Ext:</label>
                      <span className="sp-margin5">
                        {detailObj?.fax?.substring(10, detailObj?.fax.length)}
                      </span>
                    </div>
                    <div>
                      <label>NPI:</label>
                      <span className="sp-margin5">{detailObj?.npi}</span>
                    </div>
                    {/*{sharedObject?.AdvSearchAnswers?.DirectoryType !==*/}
                    {/*    "Providers" ? (*/}
                    {/*    <div>*/}
                    {/*        <label>Organization Type:</label>*/}
                    {/*        <span className="sp-margin5">{detailObj?.orgKind}</span>*/}
                    {/*    </div>*/}
                    {/*) : null}*/}
                    <hr />
                    <div>
                      <label>Specialty</label>
                    </div>
                    <div className="field-wrapper sub-catg">
                      <label for=" SpecialtyType">Type:</label>
                      <span> {detailObj?.specialityType}</span>
                      <br />
                      <label for=" Classification">Classification:</label>
                      <span>{detailObj?.specialityCLassification}</span>
                      <br />
                      <label for=" Specialization">Specialization:</label>
                      <span>{detailObj?.specializationCode}</span>
                    </div>
                    
                  </section>
                    <div >
                        <label>Direct</label>
                    </div>
                  {!detailObj?.directEmail ? (
                    <>
                      <div className="field-wrapper sub-catg ctr">
                        You currently do not have any emails.
                      </div>
                    </>
                  ) : (
                    <div className="field-wrapper o-flow">
                      <table>
                        <tr>
                          <th>Email</th>
                          <th>Purpose</th>
                        </tr>
                        <tr>
                          <td className="word-set">{detailObj?.directEmail}</td>
                          <td className="w-sm">{detailObj?.emailPurpose}</td>
                        </tr>
                      </table>
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-outline-secondary" data-dismiss="modal" >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

DetailsDirectory.defaultProps = {};

export default DetailsDirectory;
